
import { Package } from "lucide-react";
import MembershipCard from "@/components/MembershipCard";

interface Membership {
  id: string;
  name: string;
  session_count?: number | null;
  price: number; // Changed from string to number
  membership_type: string;
  is_subscription: boolean;
  services?: Array<{
    id: string;
    name: string;
    duration_minutes: number;
  }>;
}

interface MembershipsTabProps {
  memberships: Membership[] | undefined;
  membershipsLoading: boolean;
  providerId?: string;
}

const MembershipsTab = ({ memberships, membershipsLoading, providerId }: MembershipsTabProps) => {
  if (membershipsLoading) {
    return (
      <div className="space-y-6">
        <div>
          <h3 className="text-lg font-semibold mb-4">Membership Packages</h3>
          <p className="text-gray-600 mb-6 text-sm sm:text-base">Save money with our session packages. Perfect for regular training.</p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          {[1, 2, 3].map((i) => (
            <div key={i} className="animate-pulse">
              <div className="h-48 bg-gray-300 rounded-lg"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold mb-4">Membership Packages</h3>
        <p className="text-gray-600 mb-6 text-sm sm:text-base">Save money with our session packages. Perfect for regular training.</p>
      </div>
      
      {memberships && memberships.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          {memberships.map((membership) => (
            <MembershipCard
              key={membership.id}
              membership={{
                id: membership.id,
                title: membership.name,
                sessionCount: membership.session_count || 0,
                price: membership.price, // Already a number now
                type: membership.membership_type === 'pack_of_sessions' ? 'Pack' : 
                      membership.membership_type === 'sessions_per_month' ? 'Monthly' : 
                      'Unlimited',
                services: membership.services?.map(service => ({
                  id: service.id,
                  name: service.name,
                  duration_minutes: service.duration_minutes
                })) || [],  
                is_subscription: membership.is_subscription
              }}
              providerId={providerId}
            />
          ))}
        </div>
      ) : (
        <div className="text-center py-8 text-gray-500">
          <Package className="h-12 w-12 mx-auto mb-4 text-gray-300" />
          <p>No membership packages available at this time.</p>
        </div>
      )}
    </div>
  );
};

export default MembershipsTab;
